import React from 'react';

const SolvingPeriod = () => (
  <div>
    <p>Solving Period Here</p>
  </div>
);

export default SolvingPeriod;
